import TrashIcon from 'app/ui_v2/icons/TrashIcon';
import FsLightbox from 'fslightbox-react';
import { useState } from 'react';

import { Box, CircularProgress, IconButton, SxProps } from '@mui/material';

import { FileInfo } from './MultiFileUploader2';

export interface PhotoThumbnailsProps {
  data: FileInfo[];
  isUploadActive: boolean;
  onImageRemove: (id: string) => void;
}

const getStyles = (): { [key: string]: SxProps } => {
  return {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: '0 -10px 0 -10px',
    },
    thumbnail: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '80px',
      height: '80px',
      margin: '10px',
    },
    thumbnailBg: {
      position: 'absolute',
      width: '80px',
      height: '80px',
      backgroundSize: 'cover',
      backgroundPosition: '50% 50%',
      backgroundRepeat: 'no-repeat',
      opacity: 0.4,
    },
    isLoaded: {
      opacity: 1,
      cursor: 'pointer',
    },
  };
};

export default function PhotoThumbnails(props: PhotoThumbnailsProps) {
  const { data, onImageRemove, isUploadActive } = props;

  const styles = getStyles();

  const [lightboxController, setLightboxController] = useState<{
    toggler: boolean;
    sourceIndex: number;
  }>({
    toggler: false,
    sourceIndex: 1,
  });

  function openLightboxOnSlide(number: number) {
    setLightboxController({
      toggler: !lightboxController.toggler,
      sourceIndex: number,
    });
  }

  return (
    <Box sx={styles.root}>
      {data.map((item: FileInfo, index: number) => (
        <Box sx={styles.thumbnail} key={item.uppyId || item.id}>
          <>
            <Box
              onClick={() => {
                if (item.state === 'uploaded') {
                  openLightboxOnSlide(index);
                }
              }}
              sx={{
                ...styles.thumbnailBg,
                // ...(item.isLoaded ? styles.isLoaded : {}),
              }}
              style={{ backgroundImage: `url("${item.thumbnail}")` }}
            ></Box>
            {item.state !== 'uploaded' && <CircularProgress color="secondary" size={40} />}
            {item.state === 'uploaded' && item.id && isUploadActive && (
              <Box fontSize="1.4rem" position="absolute" right="-10px" top="-10px">
                <IconButton
                  aria-label="Delete"
                  className="filled fixed-size-small"
                  onClick={() => onImageRemove(item.id || '')}
                >
                  <TrashIcon fontSize="inherit" />
                </IconButton>
              </Box>
            )}
          </>
        </Box>
      ))}
      <FsLightbox
        toggler={lightboxController.toggler}
        sources={data.map((item: FileInfo) => item.url || '')}
        onClose={() => {
          // dispatch(setGalleryState(false));
        }}
        onOpen={() => {
          // dispatch(setGalleryState(true));
        }}
        sourceIndex={lightboxController.sourceIndex}
        key={data.length}
      />
    </Box>
  );
}
